<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/p231N8/Images/MSRCover.jpg?1739571105575" alt="This image is the cover for the book Romano's Revenge"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Romano's Revenge
      </h1>
      <p class="bookDescription body article font2">
        <p>Millionaire Joe Romano's surprise birthday gift is a live-in cook--Lucinda Barry. But the beautiful, blue-blooded blonde can't even fry an egg, so Joe instantly realizes it's all a scheme to find him a suitable wife!<br/><br/>Joe decides to take his revenge on Lucinda and his matchmaking Italian grandmother by playing them at their own game. Surely Lucinda won't mind sharing his bed as part of her domestic duties?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sandra Marton
      </h2>
      
      <p class="authorDescription body article">Sandra Marton is a USA Todday Bestselling Author. A four-time finalist for the RITA, the coveted award given by Romance Writers of America, she&#39;s also won eight Romantic Times &#160;Reviewers&rsquo; Choice Awards, the Holt Medallion, and Romantic Times&rsquo; Career Achievement Award. Sandra&#39;s heroes are powerful, sexy, take-charge men who think they have it all--until that one special woman comes along. Stand back, because together they&#39;re bound to set the world on fire.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?be9d29c4